import React, {useState} from "react";
import TaskMainContainer from "./TaskMainContainer";
import ChooseExtraItemTask from "./ChooseExtraItemTask";
import bgNature from '../images/bgNature.png';
import imgTrue from "../images/сhooseExtraItemTask/scarecrow_true.png";
import imgFalse from "../images/сhooseExtraItemTask/scarecrow_false.png";


const LogicWedge4 = (props) => {
  const [allComplete, setAllComplete] = useState(false);
  const [completedTaskCount, setCompletedTaskCount] = useState(0);

  const chooseTasks = [
    {
      title: 'There are two scarecrows. Their names are True and False. True always tells the truth. ' +
        'False always lies. Press the scarecrow which tells the truth.',
      titleFontSize: '30px',
      items: [
        {id: 1, image: imgTrue, success: true},
        {id: 2, image: imgFalse},
      ]
    },
    {
      title: '“All machines have some moving parts” \n'+
      'Who said that?',
      items: [
        {id: 1, image: imgTrue},
        {id: 2, image: imgFalse, success: true},
      ]
    },
    {
      title: '“A seesaw is a kind of levers” \n'+
      'Who said that?',
      items: [
        {id: 1, image: imgTrue, success: true},
        {id: 2, image: imgFalse},
      ]
    },
    {
      title: '“All simple machines increase the effort” \n'+
      'Who said that?',
      items: [
        {id: 1, image: imgTrue},
        {id: 2, image: imgFalse, success: true},
      ]
    },
    {
      title: '“We use wheels because it decreases the ground friction” \n'+
      'Who said that?',
      items: [
        {id: 1, image: imgTrue, success: true},
        {id: 2, image: imgFalse},
      ]
    }
  ]

  return (
    <TaskMainContainer
      lessonCode={props.lessonCode}
      tasksCount={chooseTasks.length}
      completeCount={completedTaskCount}
      setCompletedTaskCount={setCompletedTaskCount}
      taskComplete={allComplete}
    >

      {
        chooseTasks.map((item, i) => (
          <React.Fragment key={`step${i}`}>
            {
              ((completedTaskCount === (i)) || ((i+1) === chooseTasks.length && completedTaskCount >= chooseTasks.length)) ? (
                <ChooseExtraItemTask
                  lang={'en'}
                  bgImg={bgNature}
                  title={item.title}
                  items={item.items}
                  titleFontSize={item.titleFontSize}
                  taskComplete={() => {
                    setCompletedTaskCount(prevState => prevState + 1);
                    if ((i + 1) === chooseTasks.length) {
                      setAllComplete(true);
                    }
                  }}
                />
              ) : null
            }
          </React.Fragment>
        ))
      }
    </TaskMainContainer>
  )
}
export default LogicWedge4;
